import { Injectable } from '@angular/core';
import { OrderLocationGroupContract } from '../models/order-location-group.model';
import { ReadyHttpClient } from './ready-http-client';
import { IGeocodingResponse } from './contracts/geocoding.contract';

@Injectable({
  providedIn: 'root'
})
export class GeocodingApi {
  constructor(public httpClient: ReadyHttpClient) {}

  searchPlaceNames(searchString: string): Promise<IGeocodingResponse> {
    return this.httpClient.get<IGeocodingResponse>(
      `/geocoding/address/autocomplete?searchString=${encodeURIComponent(
        searchString
      )}`
    );
  }

  getClosestLocationsByPlace(
    companyDomain: string,
    searchString: string
  ): Promise<OrderLocationGroupContract> {
    return this.getClosestLocations(companyDomain, searchString);
  }

  getClosestLocationsByLatLong(
    companyDomain: string,
    lat: number,
    long: number
  ): Promise<OrderLocationGroupContract> {
    return this.getClosestLocations(companyDomain, '', lat, long);
  }

  getClosestLocationsByDistance(
    companyDomain: string
  ): Promise<OrderLocationGroupContract> {
    return this.getClosestLocations(companyDomain);
  }

  private getClosestLocations(
    companyDomain: string,
    searchString?: string,
    lat?: number,
    long?: number
  ): Promise<OrderLocationGroupContract> {
    const request = encodeURI(
      `/geocoding/locations/bydistance?companyDomain=${companyDomain}${
        !!searchString ? `&searchString=${searchString}` : ''
      }${!!lat && !!long ? `&lat=${lat}&long=${long}` : ''}`
    );

    return this.httpClient.get<OrderLocationGroupContract>(request);
  }
}
